module.exports = __webpack_public_path__ + "static/media/testimonials-1.88a74367.jpg";